import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { BroadcastMessageService } from '../../../services/broadcastMessageService';
import { AppService } from '../../../app/app.service';
import { PageContentService } from '../../../services/pagecontent.service';
import { Settings, AppSettings } from '../../../app/app.settings';

@Component({
    selector: 'app-our-services',
    templateUrl: './our-services.component.html',
    styleUrls: ['./our-services.component.scss']
})
export class OurServicesComponent implements OnInit {
    public settings: Settings;
    public latestnews;
    public langId: number;
    public flipList;
    subscription: Subscription
    

    constructor(public appService: AppService, public pageservice: PageContentService,
        private broadcastMessageService: BroadcastMessageService,
        public appSettings: AppSettings, ) {
        this.settings = this.appSettings.settings;
        this.subscription = this.broadcastMessageService.getMessage().subscribe(message => {
            this.langId = +message.text;
            this.pageservice.getHomeFlipContent(this.langId).subscribe(result => {
                
                if (result != null && result != undefined) {
                    
                    this.flipList = result;
                }
            });
        });
    }

    ngOnInit() {
        this.langId = this.settings.langId;
        this.pageservice.getHomeFlipContent(this.langId).subscribe(result => {
            if (result != null && result != undefined) {
                
                this.flipList = result;
            }
        });
    }

    goToWeeklySeminar() {

    }

}
